import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const StepsIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M14.8 12.3c.2.2 1.2.1 2.2 0-.5-.9-.9-1.8-1.2-2.8-.3-1-.7-1.9-1.2-2.9-.4-.7-1.1-.6-1.8-.6h-.4c.6 2.3 1.4 4.4 2.4 6.3"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path d="M9.2 12.4l1.6 1.2L13 12c-.2-.5-.5-1.1-.7-1.8l-3.1 2.2z" fillRule="evenodd" clipRule="evenodd" />
      <path
        d="M20.4 13.9c-.6-.2-1.2-.3-1.8-.4-1.2-.2-4.1.5-4.8-.3L12 14.5l1.4 1.1c.6.5 1.3.7 2.1.7h7.2c-.2-.9-.8-1.7-1.6-2.1-.3-.1-.5-.2-.7-.3"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M8.1 11.5l3.8-2.6c-.4-1.4-.8-2.6-.9-2.9-.2 0-.4-.1-.6-.1-.8-.2-1.4-.8-1.8-1.4-.3-.5-.8-.8-1.4-.9-.6 0-1.1.2-1.5.7L3 7.6l5.1 3.9z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M15.5 17.7c-1.1 0-2.1-.4-2.9-1l-10.4-8-.7.9c-.2.3-.4.7-.3 1.1 0 .4.2.7.5.9l10.2 7.8c.9.7 2.1 1.1 3.3 1.1h6.6c.7 0 1.3-.6 1.3-1.3v-1.3l-7.6-.2z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default StepsIcon;
